import { render, staticRenderFns } from "./CardView.vue?vue&type=template&id=a61a4e9e&scoped=true&"
import script from "./CardView.vue?vue&type=script&lang=js&"
export * from "./CardView.vue?vue&type=script&lang=js&"
import style0 from "./CardView.vue?vue&type=style&index=0&id=a61a4e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61a4e9e",
  null
  
)

export default component.exports